import styled from 'styled-components';

export const Container = styled.main`
  position: ${props => (props.shortMessage ? 'absolute' : '')};
  top: ${props => (props.shortMessage ? '0' : '')};
  left: ${props => (props.shortMessage ? '0' : '')};
  width: ${props => (props.shortMessage ? '100%' : '')};
  height: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Wrapper = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 480px;
    @media only screen and (min-width: 1460px) {
      width: 550px;
    }
  }
  .text {
    color: #000;
    text-transform: uppercase;
    font-size: 14px;
    letter-spacing: 1px;
    font-weight: 700;
    text-align: center;
  }
`;
